import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import '../styles/disenocalculadorasbase.css';

export default function CalculadoraSoloAhorrar() {
const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    // Validaciones
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }

    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <div className="calculadora-container simple-layout">
    <h1>Solo ahorrar</h1>
      <p>Nombre:</p>
      <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
      <p>Edad:</p>
      <input
        type="number"
        value={edad}
        onChange={(x) => {
          const valor = x.target.value;
          // Solo permite dos digitos para que no escriba mas el usuario 
          if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
            setEdad(valor);
          }
        }}
        min="1"
        max="99"
      />
      <p>Ingreso al fondo (mensualmente)</p>
      <input type="number" value={ingreso} onChange={(e) => setIngreso(e.target.value)} />
      <p>Tiempo</p>
      <select value={tiempo} onChange={(e) => setTiempo(e.target.value)}>
        {[...Array(20)].map((_, i) => (
          <option key={i + 1} value={i + 1}>{i + 1}</option>
        ))}
      </select>
      <p></p>
      <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>
    </div>
  )
}



